import { render, staticRenderFns } from "./SongDetailsOverlay.vue?vue&type=template&id=758cda8b&scoped=true&"
import script from "./SongDetailsOverlay.vue?vue&type=script&lang=js&"
export * from "./SongDetailsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SongDetailsOverlay.vue?vue&type=style&index=0&id=758cda8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758cda8b",
  null
  
)

export default component.exports